import { render, staticRenderFns } from "./flexibleJob_home.vue?vue&type=template&id=bc77d414&scoped=true&"
import script from "./flexibleJob_home.vue?vue&type=script&lang=js&"
export * from "./flexibleJob_home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc77d414",
  null
  
)

export default component.exports